export default "__VITE_ASSET__Cqby27R0__"